import { render, staticRenderFns } from "./company-shipping.vue?vue&type=template&id=026743d6&scoped=true&"
import script from "./company-shipping.vue?vue&type=script&lang=js&"
export * from "./company-shipping.vue?vue&type=script&lang=js&"
import style0 from "./company-shipping.vue?vue&type=style&index=0&id=026743d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026743d6",
  null
  
)

export default component.exports